export default "__VITE_ASSET__jouHRWJ6__"